import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";

import data from "./data";
import useStyles from "./style";

import Transcard from "./Transcard";

// const lang_url =
//   "https://cors-anywhere.herokuapp.com/https://api.mymemory.translated.net/languages";

//key = {{"Gujarati":"gu"},{"Hindi":"hi"}}
//lang= ["English","Gujarati"]

const Translater = () => {
  // const transData = getTransData();
  const classes = useStyles();

  const [lang, setLang] = useState();
  const [key, setKey] = useState();

  const [orgLang, setOrgLang] = useState("English");
  const [transLang, setTransLang] = useState("English");

  const [text, setText] = useState("");
  const [finalText, setFinalText] = useState("");
  const [outputText, setOutputText] = useState("");

  useEffect(() => {
    setText("");
    setFinalText("");
    setOutputText("");
  }, [orgLang]);

  useEffect(() => {
    setFinalText("");
    setOutputText("");
  }, [transLang]);

  useEffect(() => {
    setFinalText("");
    setOutputText("");
  }, [orgLang, text]);

  useEffect(() => {
    const unique = [];
    {
      Object.keys(data).map((keyName, i) => unique.push(keyName));
    }
    const codeLang = {};
    unique.map((key) => {
      let value = data[key]["2"];
      codeLang[key] = value;
    });
    setKey(codeLang);
    setLang(unique);
  }, []);

  if (lang === undefined) {
    return <></>;
  }

  const submit = (e) => {
    e.preventDefault();
    setFinalText(text);
  };

  return (
    <>
      <Grid container className={classes.container}>
        <Grid item xs={12} md={6} className={classes.searchbar}>
          <form onSubmit={(e) => submit(e)} className={classes.box}>
            <label>Select Your Language</label>
            <select
              value={orgLang}
              className={classes.formFeild}
              onChange={(e) => setOrgLang(e.target.value)}
            >
              {lang.map((l, i) => (
                <option value={l} key={i}>
                  {l}
                </option>
              ))}
            </select>
            <label>Your Input</label>
            <textarea
              value={text}
              row={100}
              cols={50}
              className={classes.textFeild}
              onChange={(e) => setText(e.target.value)}
            ></textarea>
            <button className={classes.submitBtn} type="submit">
              TRANSLATE TEXT
            </button>
          </form>
        </Grid>
        <Grid item xs={12} md={6} className={classes.searchbar}>
          <form className={classes.box}>
            <label>Select Translate Language</label>
            <select
              value={transLang}
              className={classes.formFeild}
              onChange={(e) => setTransLang(e.target.value)}
            >
              {lang.map((l, i) => (
                <option value={l} key={i}>
                  {l}
                </option>
              ))}
            </select>

            {finalText !== "" && orgLang !== transLang ? (
              <Transcard
                finalText={finalText}
                outputText={outputText}
                setOutputText={setOutputText}
                orgLang={orgLang}
                transLang={transLang}
              />
            ) : (
              <></>
            )}
          </form>
        </Grid>
      </Grid>
    </>
  );
};

export default Translater;
